
import axios from 'axios'

const baseURL = 'https://scada.pt/wp-json/catalog'

axios.defaults.baseURL = baseURL

export default {

	bootstrap: function ( cb ) {
		
		let query = '/bootstrap';

		if( 'caches' in window ) {
			
			caches.match( baseURL + query ).then(function ( res ) {
				
				if( res ) {
					console.log('CONTENT\'S IN CACHE!');
					
					res.json().then( function ( data ) {
						return cb ( data )
					})
				}
			})
		}
		
		if( navigator.onLine ){
			axios.get( query )
				.then(function ( res ) {
					return cb( res.data )
				})
				.catch(function ( err ) {
					console.log( err );
				});	
		}
	},
	update: function ( cb ) {
		
		let query = '/bootstrap';

		if( 'caches' in window ) {
			
			caches.match( baseURL + query ).then(function ( res ) {
				
				if( res ) {
					console.log('CONTENT\'S IN CACHE!');
					
					res.json().then( function ( data ) {
						return cb ( data )
					})
				}
			})
		}
		
		if( navigator.onLine ){
			axios.get( query )
				.then(function ( res ) {
					return cb( res.data )
				})
				.catch(function ( err ) {
					console.log( err );
				});	
		}
	},
	getCategories: function ( cb ) {
		
		let query = '/categories';

		if( 'caches' in window ) {
			
			caches.match( baseURL + query ).then(function ( res ) {
				
				if( res ) {
					console.log('CATEGORIES IN CACHE!');
					
					res.json().then( function ( data ) {
						return cb ( data )
					})
				}
			})
		}

		axios.get( query )
			.then(function ( res ) {
				return cb( res.data )
			})
			.catch(function ( err ) {
				console.log( err );
			});
	},

	getProducts: function ( cb ) {
			
		let query = "/products"	

		if( 'caches' in window ) {
			
			caches.match( baseURL + query  ).then(function ( res ) {
				
				if( res ) {
					console.log('PRODUCTS IN CACHE!');
					
					res.json().then( function ( data ) {
						return cb ( data )
					})
				}
			})
		}

		axios.get('/users/1')
			.then(function ( res ) {
				return cb( res.data )
			})
			.catch(function ( err ) {
				console.log( err );
			});
	}
}


// WEBPACK FOOTER //
// ./src/api/index.js